module.exports = __webpack_public_path__ + "static/media/affiliate-subscription-bg.b362ad07.png";